import { list } from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
export const SEAL_CONNECTOR_LIST = "sealConnectorList";
export function fetchSealConnectorsIfNeeded(force = false) {
  return (dispatch, getState) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(
        SEAL_CONNECTOR_LIST,
        null,
        (parent, filter) => {
          return QSignAdminApi.findSealConnectors();
        },
        force
      )
    );
  };
}
export function invalidate() {
  return dispatch => {
      dispatch(list.SimpleListActions.invalidate(SEAL_CONNECTOR_LIST));
  }
}